export default __webpack_public_path__ + "static/media/mastertrapper.513dec51.png";